import React, { useMemo } from "react";
import Element from "../../../../../../Elements/KDFElements/Element";
import ImageSlider from "./ImageSlider";
import LightBoxSlideshow from "./LightBoxSlideshow";

const LightboxContent = ({ lightbox, videoMonitor = null }) => {
    const arrayOfImageElements = useMemo(() => {
        const allElements = lightbox?.elements ?? lightbox;
        if (!lightbox || !allElements || Object.keys(allElements).length === 0) return [];
        const allValues = Object.values(allElements);
        const lightboxOnly = allValues.filter(el => el && !el.page);
        return lightboxOnly.length > 0 ? lightboxOnly : allValues;
    }, [lightbox]);

    const dimensions = { width: lightbox?.width, height: lightbox?.height };
    const isImageOnly = arrayOfImageElements.length > 0 && arrayOfImageElements.every(el => el?.element_type_name === 'Image');

    if (arrayOfImageElements.length >= 2 && isImageOnly && lightbox?.slide_show) {
        return (
            <LightBoxSlideshow
                images={arrayOfImageElements}
                intervalSeconds={lightbox?.slide_interval}
                dimensions={dimensions}
            />
        );
    }

    return arrayOfImageElements.length >= 2 && isImageOnly ?
        <ImageSlider
            arrayOfImageElements={arrayOfImageElements}
            showIcons={false}
            dimensions={dimensions}
        /> :
        <Element
            elements={Object.fromEntries(arrayOfImageElements.map(el => [el.id, el]))}
            dimensions={dimensions}
            lightbox={true}
            videoMonitor={videoMonitor}
        />;
};

export default LightboxContent;
